module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"typeUrl":"Enter site address","history":"History","historyClear":"Clear history","historyItemClear":"Remove site from list"},"ru":{"typeUrl":"Введите адрес сайта","history":"История","historyClear":"Очистить историю","historyItemClear":"Удалить сайт из списка"}}')
  delete Component.options._Ctor
}
